"use client";

import { useDialog } from "@/contexts/DialogContext";
import ProfileForm from "../ProfileForm/ProfileForm";

interface ProfileDialogProps {
  onClose?: () => void;
}

export default function ProfileDialog({ onClose }: ProfileDialogProps) {
  const { closeDialog } = useDialog();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      closeDialog("profile-dialog");
    }
  };

  return (
    <div className="bg-white w-full max-w-[525px] min-w-[525px] px-6 pt-10 pb-4">
      {/* Header */}
      <div className="mx-6 border-b border-light-grey font-raleway text-md">
        <div className="flex gap-2">
          <button className="py-1 px-2 text-center font-medium relative text-black">
            Profile
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-black"></div>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <ProfileForm onClose={handleClose} />
      </div>
    </div>
  );
} 